<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <header>
        <button @click="closeModal" class="close-button">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
              fill="black"
            />
          </svg>
        </button>
        <div class="container-header">
          <div class="container-header-title">
            <h2>{{ job.title }}</h2>
            <p>{{ job.posted }}</p>
          </div>
          <div class="buttons-div">
            <BaseButton
              label="Apply Now"
              backgroundColor="var(--s-pink-normal)"
              textColor="var(--state-white)"
              height="60px"
              width="213.5px"
              borderRadius="40px"
              @click="saveJob(job.id)"
            />
            <BaseButton
              label="Save Job"
              backgroundColor="transparent"
              icon='<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.125 0.825195C13.385 0.825195 11.715 1.6352 10.625 2.9152C9.535 1.6352 7.865 0.825195 6.125 0.825195C3.045 0.825195 0.625 3.2452 0.625 6.3252C0.625 10.1052 4.025 13.1852 9.175 17.8652L10.625 19.1752L12.075 17.8552C17.225 13.1852 20.625 10.1052 20.625 6.3252C20.625 3.2452 18.205 0.825195 15.125 0.825195ZM10.725 16.3752L10.625 16.4752L10.525 16.3752C5.765 12.0652 2.625 9.2152 2.625 6.3252C2.625 4.3252 4.125 2.8252 6.125 2.8252C7.665 2.8252 9.165 3.8152 9.695 5.1852H11.565C12.085 3.8152 13.585 2.8252 15.125 2.8252C17.125 2.8252 18.625 4.3252 18.625 6.3252C18.625 9.2152 15.485 12.0652 10.725 16.3752Z" fill="#17865F"/></svg>'
              textColor="#126B4C"
              height="60px"
              width="213.5px"
              borderRadius="40px"
              borderColor="var(--s-green-normal-active)"
              @click="saveJob(job.id)"
            />
          </div>
        </div>
      </header>
      <section class="job-details">
        <h3>Job Description</h3>
        <p class="normal-text">{{ job.description }}</p>
      </section>
      <section class="job-details">
        <h3>Need help with</h3>
        <div class="tags">
          <span v-for="tag in job.tags" :key="tag">{{ tag }}</span>
        </div>
        <div style="display: flex; gap: 24px; margin-top: 10px">
          <h3>Age : <span>63</span></h3>
          <h3>Gender : <span>Male</span></h3>
        </div>
      </section>
      <section class="job-details">
        <h3>Schedule</h3>
        <div class="time-div">
          <div>
            <svg
              width="22"
              height="16"
              viewBox="0 0 22 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 9C12.1667 9 11.4583 8.70833 10.875 8.125C10.2917 7.54167 10 6.83333 10 6C10 5.16667 10.2917 4.45833 10.875 3.875C11.4583 3.29167 12.1667 3 13 3C13.8333 3 14.5417 3.29167 15.125 3.875C15.7083 4.45833 16 5.16667 16 6C16 6.83333 15.7083 7.54167 15.125 8.125C14.5417 8.70833 13.8333 9 13 9ZM6 12C5.45 12 4.97933 11.804 4.588 11.412C4.196 11.0207 4 10.55 4 10V2C4 1.45 4.196 0.979333 4.588 0.588C4.97933 0.196 5.45 0 6 0H20C20.55 0 21.021 0.196 21.413 0.588C21.8043 0.979333 22 1.45 22 2V10C22 10.55 21.8043 11.0207 21.413 11.412C21.021 11.804 20.55 12 20 12H6ZM8 10H18C18 9.45 18.1957 8.979 18.587 8.587C18.979 8.19567 19.45 8 20 8V4C19.45 4 18.979 3.804 18.587 3.412C18.1957 3.02067 18 2.55 18 2H8C8 2.55 7.804 3.02067 7.412 3.412C7.02067 3.804 6.55 4 6 4V8C6.55 8 7.02067 8.19567 7.412 8.587C7.804 8.979 8 9.45 8 10ZM19 16H2C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V3H2V14H19V16Z"
                fill="black"
              />
            </svg>
            <p class="normal-text">N 5000 / day</p>
          </div>
          <div>
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 16C4.71667 16 4.479 15.904 4.287 15.712C4.09567 15.5207 4 15.2833 4 15C4 14.7167 4.09567 14.4793 4.287 14.288C4.479 14.096 4.71667 14 5 14C5.28333 14 5.521 14.096 5.713 14.288C5.90433 14.4793 6 14.7167 6 15C6 15.2833 5.90433 15.5207 5.713 15.712C5.521 15.904 5.28333 16 5 16ZM5 12C4.71667 12 4.479 11.904 4.287 11.712C4.09567 11.5207 4 11.2833 4 11C4 10.7167 4.09567 10.479 4.287 10.287C4.479 10.0957 4.71667 10 5 10C5.28333 10 5.521 10.0957 5.713 10.287C5.90433 10.479 6 10.7167 6 11C6 11.2833 5.90433 11.5207 5.713 11.712C5.521 11.904 5.28333 12 5 12ZM9 16C8.71667 16 8.47933 15.904 8.288 15.712C8.096 15.5207 8 15.2833 8 15C8 14.7167 8.096 14.4793 8.288 14.288C8.47933 14.096 8.71667 14 9 14C9.28333 14 9.521 14.096 9.713 14.288C9.90433 14.4793 10 14.7167 10 15C10 15.2833 9.90433 15.5207 9.713 15.712C9.521 15.904 9.28333 16 9 16ZM9 12C8.71667 12 8.47933 11.904 8.288 11.712C8.096 11.5207 8 11.2833 8 11C8 10.7167 8.096 10.479 8.288 10.287C8.47933 10.0957 8.71667 10 9 10C9.28333 10 9.521 10.0957 9.713 10.287C9.90433 10.479 10 10.7167 10 11C10 11.2833 9.90433 11.5207 9.713 11.712C9.521 11.904 9.28333 12 9 12ZM13 16C12.7167 16 12.4793 15.904 12.288 15.712C12.096 15.5207 12 15.2833 12 15C12 14.7167 12.096 14.4793 12.288 14.288C12.4793 14.096 12.7167 14 13 14C13.2833 14 13.5207 14.096 13.712 14.288C13.904 14.4793 14 14.7167 14 15C14 15.2833 13.904 15.5207 13.712 15.712C13.5207 15.904 13.2833 16 13 16ZM13 12C12.7167 12 12.4793 11.904 12.288 11.712C12.096 11.5207 12 11.2833 12 11C12 10.7167 12.096 10.479 12.288 10.287C12.4793 10.0957 12.7167 10 13 10C13.2833 10 13.5207 10.0957 13.712 10.287C13.904 10.479 14 10.7167 14 11C14 11.2833 13.904 11.5207 13.712 11.712C13.5207 11.904 13.2833 12 13 12ZM2 20C1.45 20 0.979 19.8043 0.587 19.413C0.195667 19.021 0 18.55 0 18V4C0 3.45 0.195667 2.97933 0.587 2.588C0.979 2.196 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.021 2.196 17.413 2.588C17.8043 2.97933 18 3.45 18 4V18C18 18.55 17.8043 19.021 17.413 19.413C17.021 19.8043 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6Z"
                fill="black"
              />
            </svg>

            <p class="normal-text">Saturday, 10th April 2024</p>
          </div>
          <div>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99163 0.666992C4.39163 0.666992 0.666626 4.40033 0.666626 9.00033C0.666626 13.6003 4.39163 17.3337 8.99163 17.3337C13.6 17.3337 17.3333 13.6003 17.3333 9.00033C17.3333 4.40033 13.6 0.666992 8.99163 0.666992ZM8.99996 15.667C5.31663 15.667 2.33329 12.6837 2.33329 9.00033C2.33329 5.31699 5.31663 2.33366 8.99996 2.33366C12.6833 2.33366 15.6666 5.31699 15.6666 9.00033C15.6666 12.6837 12.6833 15.667 8.99996 15.667ZM9.41663 4.83366H8.16663V9.83366L12.5416 12.4587L13.1666 11.4337L9.41663 9.20866V4.83366Z"
                fill="black"
              />
            </svg>

            <p class="normal-text">Mornings 09:00 AM</p>
          </div>
        </div>
      </section>
       <section class="job-details-last">
        <h3>Preferences</h3>
        <div class="tags">
          <span v-for="tag in job.tags" :key="tag">{{ tag }}</span>
        </div>
         <h3>Additional Details</h3>
         <p class="normal-text">Donec euismod lorem eget laoreet rutrum. Pellentesque vitae urna id urna ornare iaculis. Nulla facilisi. In hac habitasse platea dictumst. </p>
        
      </section>
     

     
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton.vue";
import { useRouter } from "vue-router";
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    job: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const closeModal = () => {
      emit("close");
    };

    const saveJob = (jobId) => {
      console.log(`Job ${jobId} saved!`);
      // Implement save job logic here
      router.push("/caregiver/job-application")
    };

    return {
      ...props,
      closeModal,
      saveJob,
    };
  },
  components: {
    BaseButton,
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 24px 32px;
  max-width: 967px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y:auto;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.job-details {
  margin-top: 20px;
  padding-bottom: 32px;
  margin-bottom: 32px;
  border-bottom: 1px solid #979797;
}
.job-details-last {
  margin-top: 20px;
  padding-bottom: 32px;
  margin-bottom: 32px;
 
}
.job-details-last h3{
    margin-top: 32px;
}
.tags {
  margin-top: 10px;
}

.tags span {
  background: #ececec;
  border-radius: 12px;
  margin-right: 8px;

  font-size: 14px;
  font-weight: 400;
  line-height: 23.8px;
  letter-spacing: 0.5px;
  text-align: left;

  height: 44px;
  padding: 10px;
  box-sizing: border-box;

  border-radius: 12px;

}

footer {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.apply-button,
.save-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.apply-button {
  background: #28a745;
  color: #fff;
}

.save-button {
  background: #007bff;
  color: #fff;
}

h2 {
  font-size: 24px;
  font-weight: 700;
  line-height: 31.2px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-top: 0px;
  margin-bottom: 4px;
}
.container-header {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 32px;
}
.buttons-div {
  display: flex;
  gap: 16px;
}
p {
  font-size: 12px;
  font-weight: 400;
  line-height: 20.4px;
  letter-spacing: 0.5px;
  text-align: left;
}
h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: justified;
  margin-bottom: 16px;
}
.normal-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: justified;
}
h3 span {
  font-size: 16px;
  font-weight: 400;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: justified;
}
.time-div {
  display: flex;
  gap: 26px;
}
.time-div div {
  display: flex;
  flex-direction: column;
  height: 53px;
  justify-content: space-between;
  padding-left: 10px
}
@media (max-width: 800px) {
  .modal-content{
    max-width: 300px;
  }
  .container-header{
    flex-direction: column;
  }
  .buttons-div{
    flex-direction: column;
    margin-top: 10px
  }
  .tags{
    display: flex;
    flex-direction: column;
    gap: 10px
  }
  .time-div{
    flex-direction: column;
  }
}
</style>
